export default {
    car: 0,
    flight: 1,
    hotel: 2,
    eurostar: 3,
    rail: 4,
    seat: 5,
    eurail: 8,
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-types.js